import { render, staticRenderFns } from "./complain-list.vue?vue&type=template&id=16c80987&scoped=true&"
import script from "./complain-list.vue?vue&type=script&lang=js&"
export * from "./complain-list.vue?vue&type=script&lang=js&"
import style0 from "./complain-list.vue?vue&type=style&index=0&id=16c80987&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c80987",
  null
  
)

export default component.exports